import { Spinner, Table } from "react-bootstrap";
import { axiosGetWithHeader,ShowAlertError2 } from "../../Common/axios";
import { useMemo, useState } from "react";
import { useNavigate } from "react-router-dom";

export function RecentlyViewed()  {
  const [spinner, setSpinner] = useState('Loading - Recent clients');
  const [userData, setUserData] = useState(null);
  const navigate = useNavigate();
  const [errorAlert, setErrorAlert] = useState(null);

    useMemo(() => {
        axiosGetWithHeader("/users/recent",
            (response)=>{
                setUserData(response.data);
                setSpinner(null);
              },
              (error)=>{
                setUserData(null);
                setSpinner(null);
                console.log(error);
                setErrorAlert(error.message);
              }
        );
    }, []);

    function handleClick(runningId){
        axiosGetWithHeader("/users/history/"+runningId, 
            (response)=>{
              console.log(response.message);
            },
            (error)=>{
              console.log(error);
            }
        );
        setTimeout(() => {
            navigate('/kpastro.html', { state:{runningId:runningId}, replace: true });
            navigate(0);
          }, 100);
    }

    return (
      <>
        {spinner===null?<></>:<>{spinner} <Spinner animation="border" size="sm" /></>}
        <div class="m-2 p-0 row align-items-top content ">
            <div class="m-0 p-0 col-sm-12 col-md-12 text-center">
        <Table responsive border-none hover size="sm" className="caption-top m-0 p-0 ">
            <caption className="text-center">
                <h5>Recently Viewed</h5>
            </caption>
        </Table>

        <div class="row m-0 p-0 w-100 border rounded">
            <div class="col m-0 p-3 justify-content-center">
        <Table responsive border-none hover size="sm" className="caption-top m-0 p-0 ">
            <thead>
                <tr class=" m-2 p-2">
                <th class="bg-transparent">#</th>
                <th class="bg-transparent">Name</th>
                <th class="bg-transparent">Date</th>
                </tr>
            </thead>
            <tbody>
            { userData===null || userData===undefined || userData.length===0?
                <>
                <tr>
                    <td colSpan={3} class="bg-transparent">You have not viewed any user recently.</td>
                </tr>
                </>
                :
                <>
                {userData.map((user, rowindex) => (
                <tr onClick={e=>handleClick(user.runningId)}>
                <td class="bg-transparent">{user.runningId}</td>
                <td class="bg-transparent text-start">{user.firstName} {user.lastName}</td>
                <td class="bg-transparent">{user.date}</td>
                </tr>
                ))}
               </> 
            }
            </tbody>
        </Table>
            </div>
        </div>
        </div>
        </div>
        <ShowAlertError2 errorAlert={errorAlert} setErrorAlert={setErrorAlert}/>
      </>
    );
  }
  